import { createAkiliApi } from '../../utils/api/api-methods'

const url = '/auth0/verification-email'

const sendEmailVerificationAPI = (authToken: string) => {
  return createAkiliApi(authToken, `${url}`, 'POST')
}

export default sendEmailVerificationAPI
